import { Component, OnInit, ViewChild } from '@angular/core';
import { LiveChatWidgetModel, LiveChatWidgetApiModel } from '@livechat/angular-widget';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { RouterService } from 'src/app/services/router/router.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { Location } from '@angular/common'

@Component({
  selector: 'app-live-chat',
  templateUrl: './live-chat.page.html',
  styleUrls: ['./live-chat.page.scss'],
})
export class LiveChatPage implements OnInit {

  licenseId: string;

  @ViewChild('liveChatWidget', { static: false }) public liveChatWidget: LiveChatWidgetModel;
  public isLiveChatWidgetLoaded: boolean = false;
  public liveChatApi: LiveChatWidgetApiModel;
  
  constructor(private storageService: StorageService,
    private remoteConfig: RemoteConfigService,
    private routerService: RouterService,
    private _location: Location) { }

  async ngOnInit() {
    const licenseId = await this.storageService.get('license-id');
    if (licenseId && licenseId.length > 0) {
      this.licenseId = licenseId;
    } else {
      this.remoteConfig.getInfoApp().subscribe((data: any) => {
        if (data['license-id']) {
          this.licenseId = data['license-id'];
          this.storageService.set('license-id', this.licenseId);
        }
      });
    }
  }

  onChatLoaded(api: LiveChatWidgetApiModel): void {
    this.liveChatApi = api;
    this.isLiveChatWidgetLoaded = true;
  }

  onChatWindowMinimized() {
    console.log('minimized')
    this.liveChatApi.hide_chat_window();
    this.liveChatWidget.hideChatWindow();
  }

  onChatWindowOpened() {
    console.log('opened')
    this.liveChatApi.open_chat_window();
  }

  openChatWindow(): void {
    if (this.isLiveChatWidgetLoaded) {
      this.liveChatApi.open_chat_window();
      this.liveChatWidget.openChatWindow();
    };
  }

  hideChatWindow() {
    if (this.isLiveChatWidgetLoaded) {
      this.liveChatWidget.minimizeChatWindow();
    };
  }

  goBack(){
    this._location.back()
  }

}
